<section class="request__filter" *ngIf="authService.isAuthenticated() && requestOperationType !== 'todefine'">
  <app-request-filters [formGroup]="formGroup" #filters (valueChanges)="valuesFilterChanges()"></app-request-filters>
  <section class="requests__filter-retailers" *ngIf="showRetailerList()">
    <scc-dsm3-radio-dropdown-control
      #retailerId
      [formGroup]="formGroup"
      formName="retailer"
      [options$]="retailersOptions$"
      placeholder="Seleccionar Comercializadora"
      btnFilterLabel="Aplicar"
      (onOpen)="onOpenDropdownRadioCategories()"
    >
    </scc-dsm3-radio-dropdown-control>
  </section>
</section>

<section class="request__content" *ngIf="authService.isAuthenticated()">
  <ng-template [ngIf]="authService.isAuthenticated()">
    <div class="request__container">
      <div [class.request__grid]="!isRet && requestOperationType !== 'todefine' && menuList">
        <div class="request__folders" *ngIf="!isRet && requestOperationType !== 'todefine'" [class.active]="menuList">
          <app-tree [directories]="menuList" (choice)="setFolder($event)"></app-tree>
        </div>
        <div class="request__table">
          <scc-dsm3-table
            [columns]="viewModel.columnsTable"
            [total]="totalItems"
            [rows]="requestTableData.requests"
            labelCount="Pedidos"
            [labelEmpty]="emptyLabel"
            [hasExport]="true"
            labelExport="Exportar excel"
            (onExport)="export()"
            [checkLine]="false"
            [shadownLine]="true"
            [hasBtnAdd]="false"
            [isClickableRow]="false"
          >
            <scc-dsm3-tbody-column prop="statusTitle">
              <ng-template let-column="column">
                <span class="request__tbody-span-status" [ngClass]="column.row.statusClass">{{ column.value }}</span>
              </ng-template>
            </scc-dsm3-tbody-column>

            <scc-dsm3-tbody-column prop="requestMainId">
              <ng-template let-column="column">
                <div class="request__tbody-box-span">
                  <span class="request__tbody-span span">{{ column.row.requestOperationType }}</span>
                  <a
                    class="cursor-pointer"
                    href="#"
                    (click)="openRequestDetail(column.row.requestUniqueCode); $event.preventDefault()"
                    (keyup.enter)="openRequestDetail(column.row.requestUniqueCode)"
                  >
                    {{ column.value }}
                  </a>
                </div>
              </ng-template>
            </scc-dsm3-tbody-column>

            <scc-dsm3-tbody-column prop="requestCpe">
              <ng-template let-column="column">
                <span class="request__tbody-span">{{ column.value }}</span>
              </ng-template>
            </scc-dsm3-tbody-column>

            <scc-dsm3-tbody-column prop="requestType">
              <ng-template let-column="column">
                <span class="request__tbody-span">{{ column.value }}</span>
              </ng-template>
            </scc-dsm3-tbody-column>

            <scc-dsm3-tbody-column prop="requestSubType">
              <ng-template let-column="column">
                <div class="request__tbody-box-sub-type-span">
                  <span class="request__tbody-span">{{ column.value }}</span>
                </div>
              </ng-template>
            </scc-dsm3-tbody-column>

            <scc-dsm3-tbody-column prop="createdAt">
              <ng-template let-column="column">
                <span class="request__tbody-span">{{ column.value | date: 'dd/MM/yyyy' }}</span>
              </ng-template>
            </scc-dsm3-tbody-column>
          </scc-dsm3-table>
        </div>
      </div>
      <scc-dsm3-table-pagination-number
        *ngIf="requestTableData.requests.length > 0"
        #paginationControl
        [currentPage]="currentRequestPage"
        [perPage]="paginationPerPage"
        [total]="totalItems"
        [options]="selectPaginationOption"
        [defaultOption]="10"
        [onlyNextPreviousPage]="false"
        (onChange)="paginationChange($event)"
      >
      </scc-dsm3-table-pagination-number>
    </div>
  </ng-template>
</section>
